// src/ui/chart.js — graficos simples (SVG/CSS, sem libs).
import { el } from '../lib/dom.js';

const PALETA = ['#1f9d5c', '#3b82f6', '#e0483b', '#d99a16', '#8b5cf6', '#0ea5e9', '#ec4899', '#14b8a6', '#f97316', '#64748b'];
export function corPaleta(i) { return PALETA[i % PALETA.length]; }

/** Legenda: itens [{nome, cor}]. */
export function legenda(itens) {
  return el('div', { class: 'chart-leg' }, itens.map((i) => el('span', { class: 'chart-leg__item' }, [
    el('span', { class: 'chart-leg__dot', style: `background:${i.cor}` }),
    el('span', { text: i.nome }),
  ])));
}

/** Barras horizontais: itens [{rotulo, valor, cor?}]. */
export function barrasH(itens, { cor = 'var(--verde)' } = {}) {
  const max = Math.max(1, ...itens.map((i) => i.valor || 0));
  return el('div', { class: 'chart-h' }, itens.map((i) => el('div', { class: 'chart-h__row' }, [
    el('div', { class: 'chart-h__lab', text: i.rotulo, title: i.rotulo }),
    el('div', { class: 'chart-h__barwrap' }, [el('div', { class: 'chart-h__bar', style: `width:${Math.round(((i.valor || 0) / max) * 100)}%;background:${i.cor || cor}` })]),
    el('div', { class: 'chart-h__val', text: String(i.valor || 0) }),
  ])));
}

/** Barras verticais simples: itens [{rotulo, valor}]. */
export function barrasV(itens) {
  const max = Math.max(1, ...itens.map((i) => i.valor || 0));
  return el('div', { class: 'chart-v' }, itens.map((i) => el('div', { class: 'chart-v__col', title: `${i.rotulo}h: ${i.valor || 0}` }, [
    el('div', { class: 'chart-v__barwrap' }, [el('div', { class: 'chart-v__bar', style: `height:${Math.round(((i.valor || 0) / max) * 100)}%` })]),
    el('div', { class: 'chart-v__lab', text: i.rotulo }),
  ])));
}

/** Barras verticais EMPILHADAS por serie. labels [str], series [{nome,cor,valores:[]}]. */
export function barrasVempilhada(labels, series) {
  const totais = labels.map((_, i) => series.reduce((s, se) => s + (se.valores[i] || 0), 0));
  const max = Math.max(1, ...totais);
  return el('div', { class: 'chart-v' }, labels.map((lab, i) => el('div', { class: 'chart-v__col', title: `${lab}h: ${totais[i]}` }, [
    el('div', { class: 'chart-v__barwrap' }, [
      el('div', { class: 'chart-v__stack', style: `height:${Math.round((totais[i] / max) * 100)}%` },
        series.filter((se) => se.valores[i]).map((se) => el('div', { class: 'chart-v__seg', style: `flex:${se.valores[i]};background:${se.cor}`, title: `${se.nome}: ${se.valores[i]}` }))),
    ]),
    el('div', { class: 'chart-v__lab', text: lab }),
  ])));
}

/** Barras horizontais EMPILHADAS por tipo. itens [objs], series [{chave,nome,cor}], getRotulo(item). */
export function barrasHempilhada(itens, series, getRotulo) {
  const tot = (it) => series.reduce((s, se) => s + (it[se.chave] || 0), 0);
  const max = Math.max(1, ...itens.map(tot));
  return el('div', { class: 'chart-h' }, itens.map((it) => el('div', { class: 'chart-h__row' }, [
    el('div', { class: 'chart-h__lab', text: getRotulo(it), title: getRotulo(it) }),
    el('div', { class: 'chart-h__barwrap' }, [
      el('div', { class: 'chart-h__stackh', style: `width:${Math.round((tot(it) / max) * 100)}%` },
        series.filter((se) => it[se.chave]).map((se) => el('div', { class: 'chart-h__seg', style: `flex:${it[se.chave]};background:${se.cor}`, title: `${se.nome}: ${it[se.chave]}` }))),
    ]),
    el('div', { class: 'chart-h__val', text: String(tot(it)) }),
  ])));
}
